<template>
    <div class="ml-md mt-md">
        <h2 class="align-center">训练报告</h2>
        <div class="d-flex justify-start">
            <h4 class="mr-md">姓名：{{ user.name }}</h4>
            <h4 class="mr-md">性别：{{$common.sex.find(e => e.value === user.sex).text}}</h4>
            <h4>出生日期：{{ $moment(user.birthday).format('YYYY年MM月DD日') }}</h4>
        </div>
        <br />
        <div class="d-flex justify-start">
            <h4 class="mr-md">训练日期：{{ $moment(data.beginTime).format('YYYY年MM月DD日') }}</h4>
            <h4>训练时长：{{ formatTimeDuration(data.endTime, data.beginTime) }}</h4>
        </div>
        <br />
        <Table :disabled-hover="true" :columns="columns" :data="data.trains"></Table>
    </div>
</template>

<script type="text/javascript">
export default {
    props: {
        user: Object,
        data: Object
    },
    data() {
        return {
            columns: [
                {
                    title: '维度名称',
                    key: 'dimensionName'
                },
                {
                    title: '得分',
                    key: 'score'
                }
            ]
        }
    },
    async beforeDestroy() { },
    async created() {
        console.log('诊断记录表------------->', this.data, this.user);
    },
    async mounted() { },
    methods: {
        formatTimeDuration(endTime, beginTime) {
            let ms = endTime - beginTime;
            let seconds = Math.floor(ms / 1000);
            const hours = Math.floor(seconds / 3600);
            seconds %= 3600;
            const minutes = Math.floor(seconds / 60);
            seconds %= 60;
            return [hours, minutes, seconds]
                .map(v => String(v).padStart(2, '0'))
                .join(':');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/prints/TrainResult.vue